import React from "react";

const Logo = () => {
  return (
    <div className="logo">
      <img src="/imgs/aniobi_transparent_amber.png" alt="" />
    </div>
  );
};

export default Logo;
